export enum ContentTheme {
    default = 'default'
}